export enum Flute {
    Start = 0,
    Shuffle = 1,
    Fluteless = 2,
}